import React, { useState } from "react";
import Services from "../components/Services";
import Services2 from "../components/Services2";
import Profile from "../components/Profile";
import Galary from "../components/Galary";
import ContactModal from "../components/ContactModal";
import Header from "../components/Header";
//import PDFButton from "../components/PdfButton"; // If you use Header here

const Home = () => {
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(prev => !prev);

    return (
        <div>
            <Header onContactClick={toggleModal} /> {/* if Header is here */}
            
            <section id="profile">
                <Profile />
            </section>
            <section id="services">
                <Services />
            </section>
            <section id="services2">
                <Services2 />
            </section>
{/*             <section id="pdfButton">
                <PDFButton/>
            </section> */}
            <section id="galary">
                <Galary />
            </section>
            <ContactModal show={showModal} onClose={toggleModal} />
        </div>
    );
};
export default Home;